<div class="flex my-5 justify-content-center align-items-center text-center" *ngIf="toastInfo.isOpen">
    <!--state loading-->
    <div class="flex justify-content-center align-items-center" style="height: 75vh;" *ngIf="toastInfo.state === ''">
        <p-progressSpinner></p-progressSpinner>
    </div>
    <!--state loading-->
    <div class="w-7 p-5 flex flex-column align-items-center shadow-2" *ngIf="toastInfo.state != ''">
        <!--state success begin-->
        <!--        <div class="flex align-items-center text-green-500 border-bottom-2 pb-3" *ngIf="toastInfo.state === 'success'">-->
        <!--            <i class="pi pi-check-circle mr-3" style="font-size: 5rem;"></i>-->
        <!--            <h2>{{ 'sipo.task-uploaded-successfully' | translate }}</h2>-->
        <!--        </div>-->
        <!--state success end-->
        <!--state failed begin-->
        <div class="flex align-items-center justify-content-center pb-3"
             *ngIf="toastInfo.state === 'error'">
            <div>
                <p class="mb-5">
                    <img src="assets/images/sipo/nokimza.svg">
                </p>
                <h2 class="text-red-500">{{ 'sipo.task-upload-failed' | translate }}</h2>
                <p>{{ 'sipo.task-upload-failed-info' | translate }}</p>
            </div>
        </div>
        <!--state failed end-->
        <div class="mt-3" *ngIf="toastInfo.isSelfSign && selfSignUrl.length > 0">
            <h4>{{ 'sipo.your-document-is-ready-for-signing' | translate }}</h4>
            <p>{{ 'sipo.click-the-button-info' | translate }}</p>
            <!--<p class="text-blue-500">https://link-to-sign.com/sign/access-code:thsY3735875IYdhkgdsg435976</p>-->
            <p-button (click)="signDocument()">
                <a [href]="selfSignUrl"
                   style="text-decoration: none;" class="text-white">
                    <i class="pi pi-file-o"></i>
                    {{ 'sipo.sign-the-document' | translate }}
                </a>
            </p-button>
            <p class="mt-2">{{ 'sipo.link-is-private-info' | translate }}</p>
        </div>
    </div>
</div>

